var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.72852H14.875V12.8117H12.75V5.72852Z",
    fill: "#141320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20837 5.72852H11.3334V12.8117H9.20837V5.72852Z",
    fill: "#141320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66681 5.72852H7.79186V12.8117H5.66681V5.72852Z",
    fill: "#141320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12488 5.72852H4.24993V12.8117H2.12488V5.72852Z",
    fill: "#141320"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9374 15.2558H0.0707825C1.8818e-07 15.3974 0 15.5036 0 15.6453V17.062H16.9999V15.6453C16.9999 15.5036 16.9644 15.3974 16.9291 15.2911H15.9373L15.9374 15.2558Z",
    fill: "#141320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06262 13.8746V14.5829H15.9377V13.8746C15.9377 13.7329 15.9022 13.5912 15.8669 13.4496L1.13358 13.4495C1.09813 13.5912 1.0628 13.7329 1.0628 13.8746L1.06262 13.8746Z",
    fill: "#141320"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.823 4.13481L8.64173 0.0265915C8.53549 -0.00886382 8.42925 -0.00886382 8.32301 0.0265915L0.177273 4.09963C0.0709043 4.17041 0.00012207 4.3121 0.00012207 4.45368V5.09113H17V4.48901C17 4.31211 16.9292 4.20587 16.823 4.13495L16.823 4.13481ZM8.49999 4.66613C7.72087 4.66613 7.08329 4.02869 7.08329 3.24944C7.08329 2.47031 7.72074 1.83274 8.49999 1.83274C9.27911 1.83274 9.91669 2.47018 9.91669 3.24944C9.91669 4.02856 9.27911 4.66613 8.49999 4.66613Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFinance);
export default __webpack_public_path__ + "static/media/menu-finance.ec812b85e1ee2a48495fd1e20652de7d.svg";
export { ForwardRef as ReactComponent };